import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { ArrowUp, ArrowDown, Trash2 } from 'lucide-react';
import { ReportDraftTextBlock } from '../../types/reportDrafts';

interface ReportDraftTextBlockEditorProps {
    block: ReportDraftTextBlock;
    onTextChange: (text: string) => void;
    onRemove: () => void;
    onMoveUp?: () => void;
    onMoveDown?: () => void;
}

/** One free-text paragraph of the report, editable in place. */
const ReportDraftTextBlockEditor: React.FC<ReportDraftTextBlockEditorProps> = ({
    block,
    onTextChange,
    onRemove,
    onMoveUp,
    onMoveDown
}) => (
    <div className="report-draft-text-block d-flex gap-2 align-items-start mb-2">
        <Form.Control
            as="textarea"
            rows={Math.min(6, Math.max(2, block.text.split('\n').length))}
            value={block.text}
            placeholder="Skriv ett stycke…"
            onChange={(e) => onTextChange(e.target.value)}
        />
        <div className="d-flex flex-column">
            {onMoveUp && (
                <Button variant="link" size="sm" className="p-1" title="Flytta upp" onClick={onMoveUp}>
                    <ArrowUp size={14} />
                </Button>
            )}
            {onMoveDown && (
                <Button variant="link" size="sm" className="p-1" title="Flytta ner" onClick={onMoveDown}>
                    <ArrowDown size={14} />
                </Button>
            )}
            <Button variant="link" size="sm" className="p-1 text-danger" title="Ta bort stycket" onClick={onRemove}>
                <Trash2 size={14} />
            </Button>
        </div>
    </div>
);

export default ReportDraftTextBlockEditor;
